var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.458 20 20 15.568 20 10.2607C20 7.59777 18.7786 4.93482 16.7367 3.10987C15.4199 1.91806 13.6451 3.74301 14.981 4.97206C16.4885 6.33146 17.3474 8.21228 17.3665 10.2607C17.3665 14.2645 14.103 17.4488 10 17.4488C5.89697 17.4488 2.65267 14.2645 2.65267 10.2607C2.65267 8.21228 3.49238 6.33146 5.0191 4.95345C6.35497 3.7244 4.58016 1.89945 3.28246 3.10987C1.22138 4.91621 0 7.56053 0 10.2607C0 15.568 4.542 20 10 20ZM10 10.689C10.7443 10.689 11.2786 10.149 11.2786 9.40409V1.26631C11.2786 0.521419 10.7443 0 10 0C9.25575 0 8.74049 0.521419 8.74049 1.26631V9.40409C8.74049 10.149 9.25575 10.689 10 10.689Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_1793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.2832,
    height: 19.9316,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.41d70bb459de36016fb1379bf1f527e3.svg";
export { ForwardRef as ReactComponent };